import React from 'react'
import { Link } from 'react-router-dom'
import SEO from '../components/SEO'
import WhyChooseUs from '../components/WhyChooseUs'

export default function AboutPage() {
  const birgitteImage =
    'https://assets.auxodev.dk/cdn-cgi/image/width=1000,quality=85,format=auto/assets/f84d998e-98b3-4e41-8b24-7500b03ebc9a/birgitte-vilsgaard-portrait-v2.jpg'

  return (
    <>
      <SEO
        title="Om Birgitte"
        description="Lær Birgitte Vilsgaard at kende. Partner & IT Recruitment Specialist i Insightly Care med mange års erfaring inden for search og headhunting af IT-specialister."
      />

      {/* Header Banner */}
      <section className="bg-gradient-to-b from-slate-100 to-white py-16 border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <h1 className="text-4xl sm:text-5xl font-black text-black tracking-tight">
              Om Birgitte Vilsgaard
            </h1>
            <p className="text-lg text-black mt-3 leading-relaxed">
              Virksomhedens ansigt udadtil og primære profil bag Insightly Care – IT & Tech Recruitment.
            </p>
          </div>
        </div>
      </section>

      {/* Main Profile Content */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
            {/* Left Sidebar Profile Card */}
            <div className="lg:col-span-5">
              <div className="sticky top-28 space-y-6">
                <div className="overflow-hidden border-4 border-white bg-slate-100">
                  <img
                    src={birgitteImage}
                    alt="Birgitte Vilsgaard portrait"
                    className="w-full h-[450px] object-cover object-top"
                  />
                  <div className="p-6 bg-slate-900 text-white">
                    <h2 className="text-2xl font-black text-white">Birgitte Vilsgaard</h2>
                    <p className="text-sm text-slate-300 font-semibold mt-1">
                      Partner & IT Recruitment Specialist
                    </p>
                    <div className="mt-4 pt-4 border-t border-slate-800 space-y-2 text-xs text-slate-300">
                      <p className="flex items-center gap-2">
                        <i className="fa-solid fa-location-dot text-white" aria-hidden="true" />
                        <span>Svendborg / Odense / Hele Danmark</span>
                      </p>
                      <p className="flex items-center gap-2">
                        <i className="fa-solid fa-envelope text-white" aria-hidden="true" />
                        <a href="mailto:bgv@insightly.dk" className="hover:text-white underline whitespace-nowrap">
                          bgv@insightly.dk
                        </a>
                      </p>
                      <p className="flex items-center gap-2">
                        <i className="fa-solid fa-phone text-white" aria-hidden="true" />
                        <a href="tel:28839488" className="hover:text-white underline whitespace-nowrap">
                          28 83 94 88
                        </a>
                      </p>
                    </div>

                    <div className="mt-6">
                      <a
                        href="https://www.linkedin.com/in/birgitte-vilsgaard-9b2986b2/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="w-full py-3 bg-slate-800 hover:bg-black text-white font-bold text-xs flex items-center justify-center gap-2 transition-colors border border-slate-700"
                      >
                        <i className="fa-brands fa-linkedin text-base text-white" aria-hidden="true" />
                        <span>Besøg LinkedIn Profil</span>
                      </a>
                    </div>
                  </div>
                </div>

                {/* Quick Info Box */}
                <div className="bg-slate-50 p-6 border border-slate-200">
                  <h3 className="text-sm font-bold text-black uppercase tracking-wider mb-4">
                    Kort om Insightly Care
                  </h3>
                  <p className="text-black text-xs leading-relaxed">
                    Insightly Care er den tredje forretningsenhed i Insightly ApS (CVR: 43779362). Vores fokus er 100% dedikeret til IT- og Tech-rekruttering, hvor Birgitte Vilsgaard personligt varetager alle søge- og udvælgelsesprocesser.
                  </p>
                </div>
              </div>
            </div>

            {/* Right Detailed Content */}
            <div className="lg:col-span-7 space-y-12">
              {/* Profiltekst & Om-sektion (LinkedIn source) */}
              <div className="space-y-4">
                <h2 className="text-3xl font-extrabold text-black tracking-tight">
                  Mange års erfaring med IT & Tech Recruitment
                </h2>
                <div className="prose prose-slate text-black leading-relaxed space-y-4 text-base">
                  <p>
                    Med mange års erfaring inden for IT & Tech Recruitment, search og headhunting hjælper jeg danske virksomheder med at finde og tiltrække de skarpeste digitale talenter og IT-specialister. Mit fokus er på den personlige relation, dybe brancheforståelse og det rette match mellem virksomhedskultur og kandidatens kompetencer og værdier.
                  </p>
                  <p>
                    Det danske IT-marked er stærkt konkurrencepræget, og de dygtigste profiler sidder ofte i gode stillinger uden aktivt at søge nyt job. Derfor kræver en succesfuld rekruttering mere end et traditionelt jobopslag. Det kræver målrettet headhunting, personlig henvendelse og en troværdig dialog, hvor kandidaten føler sig set og mødt med faglig respekt.
                  </p>
                </div>
              </div>

              {/* Personlig tilgang & Hvordan hun arbejder */}
              <div className="space-y-4 pt-6 border-t border-slate-100">
                <h2 className="text-2xl font-extrabold text-black tracking-tight">
                  Hvordan Birgitte arbejder
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 pt-2">
                  <div className="p-5 bg-slate-50 border border-slate-200">
                    <div className="w-8 h-8 bg-slate-200 text-black flex items-center justify-center font-bold mb-3">
                      1
                    </div>
                    <h3 className="font-bold text-black mb-1">Direkte & Tæt Dialog</h3>
                    <p className="text-black text-xs leading-relaxed">
                      Jeg arbejder tæt sammen med virksomhedens ledelse eller HR. I møder kun mig gennem hele forløbet, hvilket sikrer fuld kontinuitet og fortrolighed.
                    </p>
                  </div>

                  <div className="p-5 bg-slate-50 border border-slate-200">
                    <div className="w-8 h-8 bg-slate-200 text-black flex items-center justify-center font-bold mb-3">
                      2
                    </div>
                    <h3 className="font-bold text-black mb-1">Dyb Tech-Forståelse</h3>
                    <p className="text-black text-xs leading-relaxed">
                      Jeg sætter mig grundigt ind i jeres tekniske behov, udviklingsmetoder og organisatoriske rammer for at finde de helt rigtige faglige profiler.
                    </p>
                  </div>

                  <div className="p-5 bg-slate-50 border border-slate-200">
                    <div className="w-8 h-8 bg-slate-200 text-black flex items-center justify-center font-bold mb-3">
                      3
                    </div>
                    <h3 className="font-bold text-black mb-1">Aktiv Search & Headhunting</h3>
                    <p className="text-black text-xs leading-relaxed">
                      Jeg kontakter relevante kandidater direkte og diskret via mit omfattende netværk og specialiserede søgemetoder.
                    </p>
                  </div>

                  <div className="p-5 bg-slate-50 border border-slate-200">
                    <div className="w-8 h-8 bg-slate-200 text-black flex items-center justify-center font-bold mb-3">
                      4
                    </div>
                    <h3 className="font-bold text-black mb-1">Grundig Matchmaking</h3>
                    <p className="text-black text-xs leading-relaxed">
                      Udover faglige kompetencer vurderes kandidatens værdier og personlige drev for at sikre et langtidsholdbart match for begge parter.
                    </p>
                  </div>
                </div>
              </div>

              {/* Hvorfor virksomheder vælger hende */}
              <div className="space-y-4 pt-6 border-t border-slate-100">
                <h2 className="text-2xl font-extrabold text-black tracking-tight">
                  Hvorfor virksomheder vælger Birgitte
                </h2>
                <ul className="space-y-3 text-sm text-black">
                  <li className="flex items-start gap-3 p-3 bg-slate-50 border border-slate-200">
                    <i className="fa-solid fa-circle-check text-black mt-1" aria-hidden="true" />
                    <span>
                      <strong className="text-black font-bold">Hurtig og præcis levering:</strong> Dyb erfaring gør, at feltet af relevante kandidater indsnævres hurtigt.
                    </span>
                  </li>
                  <li className="flex items-start gap-3 p-3 bg-slate-50 border border-slate-200">
                    <i className="fa-solid fa-circle-check text-black mt-1" aria-hidden="true" />
                    <span>
                      <strong className="text-black font-bold">Personligt ansvar:</strong> Ingen overdragelse til juniorkonsulenter. Birgitte er med fra første møde til endelig aftale.
                    </span>
                  </li>
                  <li className="flex items-start gap-3 p-3 bg-slate-50 border border-slate-200">
                    <i className="fa-solid fa-circle-check text-black mt-1" aria-hidden="true" />
                    <span>
                      <strong className="text-black font-bold">Troværdigt employer brand:</strong> Birgitte repræsenterer jeres virksomhed professionelt over for kandidaterne.
                    </span>
                  </li>
                </ul>
              </div>

              {/* Uddannelser & Certificeringer */}
              <div className="space-y-4 pt-6 border-t border-slate-100">
                <h2 className="text-2xl font-extrabold text-black tracking-tight">
                  Uddannelser & Certificeringer
                </h2>
                <div className="space-y-3">
                  <div className="p-4 border border-slate-200 bg-white flex items-start gap-4">
                    <div className="w-10 h-10 bg-slate-200 text-black flex items-center justify-center shrink-0 font-bold text-lg">
                      <i className="fa-solid fa-graduation-cap text-black" aria-hidden="true" />
                    </div>
                    <div>
                      <h3 className="font-bold text-black text-base">
                        Master i Human Resource Management & Organisation
                      </h3>
                      <p className="text-xs text-black opacity-80 mt-0.5">
                        Specialisering i strategisk talentattraktion og kompetenceudvikling i vidensvirksomheder.
                      </p>
                    </div>
                  </div>

                  <div className="p-4 border border-slate-200 bg-white flex items-start gap-4">
                    <div className="w-10 h-10 bg-slate-200 text-black flex items-center justify-center shrink-0 font-bold text-lg">
                      <i className="fa-solid fa-certificate text-black" aria-hidden="true" />
                    </div>
                    <div>
                      <h3 className="font-bold text-black text-base">
                        Certificeret i Master Person Profil (MPP) & Kompetencevurdering
                      </h3>
                      <p className="text-xs text-black opacity-80 mt-0.5">
                        Validerede værktøjer til persontest, adfærd og kandidatscreening.
                      </p>
                    </div>
                  </div>

                  <div className="p-4 border border-slate-200 bg-white flex items-start gap-4">
                    <div className="w-10 h-10 bg-slate-200 text-black flex items-center justify-center shrink-0 font-bold text-lg">
                      <i className="fa-solid fa-award text-black" aria-hidden="true" />
                    </div>
                    <div>
                      <h3 className="font-bold text-black text-base">
                        Certificeret i IT & Tech Talent Search Methodology
                      </h3>
                      <p className="text-xs text-black opacity-80 mt-0.5">
                        Avancerede headhunting-metoder og direct search af tekniske specialister.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Kompetencer & Highlights */}
              <div className="space-y-4 pt-6 border-t border-slate-100">
                <h2 className="text-2xl font-extrabold text-black tracking-tight">
                  Kompetencer & Highlights
                </h2>
                <div className="flex flex-wrap gap-2">
                  {[
                    'IT & Tech Headhunting',
                    'Executive Search & Direct Search',
                    'Software Developer Recruitment',
                    'Tech Architecture Profiler',
                    'Kandidatvurdering & Matchmaking',
                    'Sparring med C-level & HR',
                    'Employer Branding Rådgivning',
                    'Kompetencebaseret Interviewteknik',
                    'DevOps & Cloud Specialister',
                  ].map((skill, i) => (
                    <span
                      key={i}
                      className="px-3.5 py-1.5 bg-slate-100 text-black text-xs font-semibold border border-slate-300"
                    >
                      {skill}
                    </span>
                  ))}
                </div>
              </div>

              {/* Bottom CTA */}
              <div className="pt-8">
                <div className="p-8 bg-slate-900 text-white space-y-4">
                  <h3 className="text-2xl font-bold text-white">Vil du drøfte et rekrutteringsbehov?</h3>
                  <p className="text-slate-300 text-sm">
                    Kontakt Birgitte direkte for en uforpliktende samtale om hvordan Insightly Care kan hjælpe jeres virksomhed.
                  </p>
                  <div className="pt-2 flex flex-wrap gap-3">
                    <Link
                      to="/kontakt"
                      className="px-6 py-3 bg-white text-black hover:bg-slate-100 font-extrabold text-sm transition-colors"
                    >
                      Book samtale med Birgitte
                    </Link>
                    <Link
                      to="/erfaring"
                      className="px-6 py-3 bg-slate-800 hover:bg-slate-700 text-white font-bold text-sm border border-slate-700 transition-colors"
                    >
                      Se Birgittes erfaring
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <WhyChooseUs />
    </>
  )
}
